import { isValidEmail } from './member';

const { isEmptyObject } = require('utilities/common');

export function roleFormValidation(fields) {
    const errors = {};
    if (!fields.email || !isValidEmail(fields.email)) {
        errors.email = 'Email is required';
    }
    if (fields?.roles?.length === 0) {
        errors.roles = 'Please select at least one role';
    }

    if (!fields.firstName || fields.firstName.trim() === '') {
        errors.firstName = 'First name is required';
    }

    if (!fields.lastName || fields.lastName.trim() === '') {
        errors.lastName = 'Last name is required';
    }

    return { errors, isValid: isEmptyObject(errors) };
}

export function CreateroleFormValidation(fields) {
    const errors = {};
    if (fields.role?.roleName === "") {
        errors.roleName = 'Role Name is required';
    }
    // if (fields.role?.roleIcon ==="") {
    //     errors.roleIcon = 'Role Icon is required';
    // }
    if (!fields.platforms || !Object.values(fields.platforms).some(v => v)) {
        errors.platforms = 'At least one platform is required';
    }

    // If hemp platform is selected, ensure at least one active hemp permission is chosen
    if (fields.platforms?.hemp) {
        const hempPerms = Array.isArray(fields.permissions?.hempPermissions) ? fields.permissions.hempPermissions : [];
        const hasActiveHempPermission = hempPerms.some(cat => Array.isArray(cat?.permissions) && cat.permissions.some(p => p?.status === true));
        if (!hasActiveHempPermission) {
            errors.hempPermissions = 'Please select at least one role on hemp';
        }
    }
    // If hemp platform is selected, ensure at least one active hemp permission is chosen
    if (fields.platforms?.hyperwolf) {
        const hwPerms = Array.isArray(fields.permissions?.hwPermissions) ? fields.permissions.hwPermissions : [];
        const hasActivehwPermission = hwPerms.some(cat => Array.isArray(cat?.permissions) && cat.permissions.some(p => p?.status === true));
        if (!hasActivehwPermission) {
            errors.hwPermissions = 'Please select at least one role on hyperwolf';
        }
    }
    // If hemp platform is selected, ensure at least one active hemp permission is chosen
    if (fields.platforms?.stilo) {
        const stiloPerms = Array.isArray(fields.permissions?.stiloPermissions) ? fields.permissions.stiloPermissions : [];
        const hasActivestiloPermission = stiloPerms.some(cat => Array.isArray(cat?.permissions) && cat.permissions.some(p => p?.status === true));
        if (!hasActivestiloPermission) {
            errors.stiloPermissions = 'Please select at least one role on stilo';
        }
    }
    // If hemp platform is selected, ensure at least one active hemp permission is chosen
    if (fields.platforms?.pos) {
        const posPerms = Array.isArray(fields.permissions?.posPermissions) ? fields.permissions.posPermissions : [];
        const hasActiveposPermission = posPerms.some(cat => Array.isArray(cat?.permissions) && cat.permissions.some(p => p?.status === true));
        if (!hasActiveposPermission) {
            errors.posPermissions = 'Please select at least one role on pos';
        }
    }
    if (fields.platforms?.hyperdrive) {
        const hyperdrivePerms = Array.isArray(fields.permissions?.hyperdrivePermissions) ? fields.permissions.hyperdrivePermissions : [];
        const hasActiveHyperdrivePermission = hyperdrivePerms.some(cat => Array.isArray(cat?.permissions) && cat.permissions.some(p => p?.status === true));
        if (!hasActiveHyperdrivePermission) {
            errors.hyperdrivePermissions = 'Please select at least one role on hyperdrive';
        }
    }


    return { errors, isValid: isEmptyObject(errors) };
}